import {css} from 'lit';

export const loadingIconStyles = css`:root {
  --duration-fast: .3s;
  --duration-medium: .75s;
  --duration-slow: 1.2s;
  --swift-ease-out-timing-function: cubic-bezier(.25, .8, .25, 1);
  --swift-ease-out: all var(--duration-fast) var(--swift-ease-out-timing-function);
  --swift-ease-in-timing-function: cubic-bezier(.55, 0, .55, .2);
  --swift-ease-in: all var(--duration-fast) var(--swift-ease-in-timing-function);
  --swift-ease-in-out-timing-function: cubic-bezier(.35, 0, .25, 1);
  --swift-ease-in-out: all var(--duration-fast) var(--swift-ease-in-out-timing-function);
  --border-radius-none: 0;
  --border-radius-xs: 4px;
  --border-radius-s: 8px;
  --border-radius: 16px;
  --border-radius-m: 16px;
  --border-radius-l: 32px;
  --border-radius-xl: 999em;
  --color-white: #fff;
  --color-white--base: #fff;
  --color-grey: #757575;
  --color-grey--base: #757575;
  --color-grey--dark: #3d3d3d;
  --color-grey--light: #d4d4d4;
  --color-grey--x-light: #f7f7f7;
  --color-black: #000;
  --color-black--base: #000;
  --color-brand: #aa183f;
  --color-brand--base: #aa183f;
  --color-brand--accent: #1470d2;
  --color-brand--support: #00496b;
  --color-status--green: #008500;
  --color-status--orange: #ff9500;
  --color-status--yellow: #fc0;
  --color-status--red: red;
  --color-status--marked: #ffec99;
  --color-nav: #308271;
  --color-nav--base: #308271;
  --color-nav--hover: #297064;
  --color-gradient1--from: #4db380;
  --color-gradient1--to: #508a95;
  --color-gradient2--from: #62a38d;
  --color-gradient2--to: #5a908e;
  --color-gradient3--from: #e7efec;
  --color-gradient3--to: #e8eeec;
  --spacing-1: 0;
  --spacing0: 0;
  --spacing-2: .313rem;
  --spacing--: .313rem;
  --spacing-3: .625rem;
  --spacing-: .625rem;
  --spacing-4: 1.25rem;
  --spacing: 1.25rem;
  --spacing-5: 2.5rem;
  --spacing\\+: 2.5rem;
  --spacing-6: 5rem;
  --spacing\\+\\+: 5rem;
  --color-tag-green--dark: #008500;
  --color-tag-green--light: #eefcee;
  --color-tag-cyan--dark: #558891;
  --color-tag-cyan--light: #e9f0f2;
  --color-tag-purple--dark: #4e5eb1;
  --color-tag-purple--light: #e8ebfd;
  --color-tag-orange--dark: #ff9500;
  --color-tag-orange--light: #fffbf5;
  --color-tag-blue--dark: #00496b;
  --color-tag-blue--light: #deedfc;
  --color-tag-white--dark: #fff;
  --color-tag-white--light: #ffffff26;
  --brand-face: "Source Sans 3 VF", sans-serif;
  --spec-face: "Oxygen", sans-serif;
  --font-weight-semibold: 500;
  --font-weight-bold: bold;
  --font-size-button: 18px;
  --line-height-button: 20px;
  --font-size-xl: 1.4375rem;
  --line-height-xl: 30px;
  --font-size-l: 1.25rem;
  --line-height-l: 30px;
  --font-size-m: 1rem;
  --line-height-m: 1.2;
  --font-size-s: .875rem;
  --line-height-s: 20px;
  --font-size-xs: .75rem;
  --line-height-xs: 16px;
  --font-size-h1: 3rem;
  --line-height-h1: 50px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h1: 32px;
    --line-height-h1: 35px;
  }
}

:root {
  --font-size-h2: 2rem;
  --line-height-h2: 35px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h2: 28px;
    --line-height-h2: 28px;
  }
}

:root {
  --font-size-h3: 1.75rem;
  --line-height-h3: 28px;
}

@media screen and (width <= 46.9375em) {
  :root {
    --font-size-h3: 23px;
    --line-height-h3: 30px;
  }
}

:root {
  --font-size-h4: 1.4375rem;
  --line-height-h4: 30px;
  --font-size-h5: 1.25rem;
  --line-height-h5: 30px;
  --font-size-h6: .875rem;
  --line-height-h6: 20px;
}

[role="button"], [type="submit"], [type="reset"], [type="button"], button {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

[type="submit"], [type="reset"], [type="button"], button {
  color: inherit;
  font: inherit;
  line-height: inherit;
  appearance: button;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
}

input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

button::-moz-focus-inner {
  border: 0;
  padding: 0;
}

[role="button"] {
  color: inherit;
  cursor: default;
  text-align: center;
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
  text-decoration: none;
  display: inline-block;
}

*, :before, :after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  tab-size: 4;
  font-family: system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji;
  line-height: 1.15;
}

body {
  margin: 0;
}

b, strong {
  font-weight: bolder;
}

code, kbd, samp, pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub, sup {
  vertical-align: baseline;
  font-size: 75%;
  line-height: 0;
  position: relative;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

table {
  border-color: currentColor;
}

button, input, optgroup, select, textarea {
  outline: none;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
}

button, [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: button;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button {
  height: auto;
}

::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

:root {
  line-height: 1.5;
}

h1, h2, h3, h4, h5, figure, p, ol, ul {
  margin: 0;
}

ol[role="list"], ul[role="list"] {
  padding-inline: 0;
  list-style: none;
}

h1, h2, h3, h4, h5 {
  font-size: inherit;
  font-weight: inherit;
}

img {
  max-inline-size: 100%;
  display: block;
}

button {
  text-align: inherit;
  cursor: pointer;
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

label {
  cursor: pointer;
  display: block;
}

p a, h1 a, h2 a, h3 a, h4 a, h5 a, h6 a {
  color: inherit;
}

input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
  appearance: none;
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  background-color: var(--color-white);
  border-radius: var(--border-radius-m);
  border: 1px solid var(--color-grey--light);
  color: var(--color-grey--dark);
  width: 100%;
  padding: 14px 15px;
}

@media screen and (width <= 46.9375em) {
  input[type="text"], input[type="email"], input[type="password"], input[type="search"]:not(.vs__search), input[type="color"], input[type="date"], input[type="datetime-local"], input[type="month"], input[type="number"], input[type="tel"], input[type="time"], input[type="url"], input[type="week"], input[list], select, textarea {
    font-size: var(--font-size-m);
    line-height: var(--line-height-s);
  }
}

input[type="date"], input[type="datetime-local"] {
  min-height: 50px;
}

input[type="text"]:read-only, input[type="email"]:read-only, input[type="password"]:read-only, input[type="search"]:read-only, input[type="color"]:read-only, input[type="date"]:read-only, input[type="datetime-local"]:read-only, input[type="month"]:read-only, input[type="number"]:read-only, input[type="tel"]:read-only, input[type="time"]:read-only, input[type="url"]:read-only, input[type="week"]:read-only, input[list]:read-only {
  background-color: var(--color-grey--x-light);
  box-shadow: none !important;
}

input[name*="postcode"], input[name*="Postal"], input[name*="postal"] {
  text-transform: uppercase;
}

::placeholder {
  color: var(--color-grey);
}

html {
  background-color: var(--color-white);
  font-size: var(--font-size-m);
  line-height: var(--line-height-m);
  color: var(--color-grey--dark);
  -webkit-font-smoothing: antialiased;
  scrollbar-gutter: stable;
  overflow-y: scroll;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--color-grey--light);
}

p {
  margin: 0 0 20px;
}

ol, ul {
  padding-left: 20px;
}

summary {
  cursor: pointer;
}

abbr[title] {
  text-decoration: none;
}

img {
  max-width: 100%;
}

@media screen and (width <= 46.9375em) {
  img[data-lazyload-src][style*="height"], img[data-lazyload-src][height], img[src][style*="height"], img[src][height] {
    max-width: 100% !important;
    height: auto !important;
  }
}

table {
  width: 100%;
}

table td {
  vertical-align: top;
  padding: 0;
}

body {
  font-family: var(--brand-face);
}

h1, h2, h3 {
  font-style: italic;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: bold;
}

h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
}

h2 {
  font-size: var(--font-size-h2);
  line-height: var(--line-height-h2);
}

h3 {
  font-size: var(--font-size-h3);
  line-height: var(--line-height-h3);
}

h4 {
  font-size: var(--font-size-h4);
  line-height: var(--line-height-h4);
}

h5 {
  font-size: var(--font-size-h5);
  line-height: var(--line-height-h5);
}

h6 {
  font-size: var(--font-size-h6);
  line-height: var(--line-height-h6);
  margin: 0;
}

strong, b {
  font-weight: bold;
}

small {
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
}

button, a {
  text-decoration: none;
}

button:hover, a:hover, p a {
  text-decoration: underline;
}

p a:hover {
  text-decoration: none;
}

:has( + bc-tooltip:not([data-trigger-style])) {
  color: var(--color-status--red);
  position: relative;
}

:has( + bc-tooltip:not([data-trigger-style])):before {
  content: "Missing attribute 'data-trigger-style'";
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);
  color: var(--color-white);
  background-color: var(--color-status--orange);
  z-index: 40;
  border-radius: 5px;
  width: 200px;
  padding: 3px 10px;
  position: absolute;
  top: 20px;
}

:has( + bc-tooltip[data-trigger-style="dashed"]) {
  text-underline-offset: .2rem;
  text-decoration: underline from-font dashed;
}

:has( + bc-tooltip[data-trigger-style="info-icon"]):after, :has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  background-image: url("https://cdn.wechseljetzt.de/assets/wj/img/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  width: 5px;
  height: 11px;
  margin-left: 5px;
  display: inline-block;
}

:has( + bc-tooltip[data-trigger-style="info-icon-border"]):after {
  content: "";
  border: 1px solid var(--color-grey);
  border-radius: var(--border-radius-xl);
  margin-bottom: -3px;
  padding: 9px 10px 10px;
}

bc-tooltip:not(:defined) {
  display: none;
}

:is(bc-tabs:not(:defined), bc-tab:not(:defined), bc-loading-icon:not(:defined), bc-abbr:not(:defined)) {
  display: block;
}

.bc-loading {
  flex-direction: column;
  align-items: center;
  display: flex;
}

.bc-loading:not(.bc-loading--inline) {
  z-index: 30;
  background: var(--color-grey--x-light);
  opacity: .8;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
}

h2 {
  text-align: center;
}

.bc-ellipsis {
  width: 80px;
  height: 80px;
  display: inline-block;
  position: relative;
}

.bc-ellipsis div {
  background: var(--color-grey--dark);
  border-radius: 50%;
  width: 13px;
  height: 13px;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
  position: absolute;
  top: 33px;
}

.bc-ellipsis div:first-child {
  animation: .6s infinite bc-ellipsis1;
  left: 8px;
}

.bc-ellipsis div:nth-child(2) {
  animation: .6s infinite bc-ellipsis2;
  left: 8px;
}

.bc-ellipsis div:nth-child(3) {
  animation: .6s infinite bc-ellipsis2;
  left: 32px;
}

.bc-ellipsis div:nth-child(4) {
  animation: .6s infinite bc-ellipsis3;
  left: 56px;
}

@keyframes bc-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bc-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes bc-ellipsis2 {
  0% {
    transform: translate(0);
  }

  100% {
    transform: translate(24px);
  }
}
`;